'use es6';

import I18n from 'I18n';
import Log from 'forms-utils-lib/logger/Logger';
import { FormErrors, FormCreationErrors, parseFormError } from 'FormsUI/api/Forms';
import { FAIL_CREATING_FORM } from 'FormsUI/actions/formCreation/formCreationActions';
import { RETRY_MAX_ATTEMPTS, failCreatingForm } from '../FormCreation';
import { convertNonHubSpotFormToHubSpotForm } from './convertNonHubSpotFormToHubSpotForm';
export const failConvertingNonHubSpotFormToHubSpotForm = () => ({
  type: FAIL_CREATING_FORM,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text('dashboard.table.collectedForms.actions.convertErrorNotification.titleText'),
      message: I18n.text(`dashboard.table.collectedForms.actions.convertErrorNotification.message`)
    }
  }
});
export const createFormXHRError = xhr => dispatch => {
  const xhrError = parseFormError(xhr);
  const createError = FormCreationErrors[xhrError];
  if (!createError) {
    Log.error(`Form creation failed with unknown error: ${createError}`);
  }
  dispatch(failCreatingForm(FormCreationErrors[xhrError] || FormCreationErrors.UNKNOWN));
};
const convertNonHubSpotFormToHubSpotFormError = ({
  xhr,
  attemptNumber,
  definition
}) => dispatch => {
  switch (xhr.status) {
    case 0:
      dispatch(failCreatingForm(FormErrors.NO_NETWORK));
      return;
    case 400:
      dispatch(failConvertingNonHubSpotFormToHubSpotForm());
      return;
    case 409:
      if (parseFormError(xhr) === FormErrors.DUPLICATE_NAME) {
        if (attemptNumber <= RETRY_MAX_ATTEMPTS) {
          Log.log(`Retrying to create form. Attempt ${attemptNumber} of ${RETRY_MAX_ATTEMPTS}.`);
          dispatch(convertNonHubSpotFormToHubSpotForm(definition, attemptNumber + 1));
          return;
        }
        // Allow for a fall-through to `default` if we exceed the retry limit.
        Log.error(`Could not create form because of a name conflict after ${attemptNumber} attempts.`);
      }
    // If we didn't know how to handle this 409, let it fall-through
    // to the default error handling.
    // eslint-disable-next-line no-fallthrough
    default:
      dispatch(createFormXHRError(xhr));
  }
};
export default convertNonHubSpotFormToHubSpotFormError;